import React, { Component } from 'react';
import logo2 from '../assets/logo2.png';
import { Link } from 'react-router-dom';



class Classes extends Component {
  state = { walletInfo: {} };
  render() {
    const { address, balance } = this.state.walletInfo;
    return (
      <div className='Classes'>
      <div><Link to='/'>Home</Link></div>
      <h3>Renbukan Dojo's Classes</h3>

      <br />
      <br />

        <div><Link to='/rosterrenbukan'>Monday 17.00-18.00</Link></div>
        <br />
        <div><Link to='/rosterrenbukan'>Monday 18.30-19.30</Link></div>
        <br />
        <div><Link to='/rosterrenbukan'>Tuesday 17.00-18.00</Link></div>
        <br />
        <div><Link to='/rosterrenbukan'>Tuesday 18.30-19.30</Link></div>
        <br />
        <div><Link to='/rosterrenbukan'>Wednesday 17.00-18.00</Link></div>
        <br />
        <div><Link to='/rosterrenbukan'>Wednesday 18.30-19.30</Link></div>
        <br />
        <div><Link to='/rosterrenbukan'>Thursday 17.00-18.00</Link></div>
        <br />
        <div><Link to='/rosterrenbukan'>Thursday 18.30-19.30</Link></div>
        <br />
        <div><Link to='/rosterrenbukan'>Friday 17.00-18.00</Link></div>
        <br />
        <div><Link to='/rosterrenbukan'>Friday 18.30-19.30</Link></div>
        <br />
        <div><Link to='/rosterrenbukan'>Saturday 13.00-15.00</Link></div>
        <br />
        <div><Link to='/rosterrenbukan'>Saturday 15.30-16.30</Link></div>
        <br />
        <div><Link to='/rosterrenbukan'>Saturday 17.00-18.00</Link></div>
        <br />
        <div><Link to='/rosterrenbukan'>Saturday 18.30-19.30(Weapons Class)</Link></div>
        <br />
        <div><Link to='/rosterrenbukan'>Sunday 13.00-15.00</Link></div>
        <br />
        <div><Link to='/rosterrenbukan'>Sunday 15.30-16.30</Link></div>

        <br />
        <div>
          Thailand's Aikido Association Class Attending System...
        </div>
          <br />
          <br />
        <div>Powered by</div><img className='logo2' src={logo2}></img><div>New Wave Consulting Group</div>
      </div>
    );
  }
}
export default Classes;
